import { Component, input } from '@angular/core';
import { EcmrStatus } from '@app/shared/models/ecmr/EcmrStatus';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@app/shared/material/material.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-ecmr-status',
    templateUrl: './ecmr-status.component.html',
    styleUrl: './ecmr-status.component.scss',
    imports: [CommonModule, MaterialModule, TranslateModule],
})
export class EcmrStatusComponent {
    status = input<EcmrStatus | undefined>();
    protected readonly EcmrStatus = EcmrStatus;

    getIcon() {
        if (this.status() === EcmrStatus.NEW) return 'fiber_new';
        else if (this.status() === EcmrStatus.LOADING) return 'forklift';
        else if (this.status() === EcmrStatus.IN_TRANSPORT)
            return 'local_shipping';
        else if (this.status() === EcmrStatus.DELIVERED)
            return 'where_to_vote';
        return '';
    }

    isActive(status: EcmrStatus) {
        const statusHierarchy = [
            EcmrStatus.NEW,
            EcmrStatus.LOADING,
            EcmrStatus.IN_TRANSPORT,
            EcmrStatus.DELIVERED,
        ];
        const currentStatus = this.status();
        if (currentStatus) {
            const currentStatusIndex = statusHierarchy.indexOf(currentStatus);
            const checkStatusIndex = statusHierarchy.indexOf(status);
            return checkStatusIndex <= currentStatusIndex;
        } else {
            return false;
        }
    }
}
